export const failureFlagsQueryKeys = {
  getExperimentsActive: (query: Record<string, string | number | null>) =>
    ['failure-flags/experiments/active', query] as const,
  getExperimentsCompletedPaged: (params: {
    pageSize: number
    teamId: string
  }) => ['failure-flags/experiments/completed/paged', params] as const
}
